/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.4",
    versionName: "0.2.0-nightly.2026.5.4",
    versionChannel: "nightly",
    buildDate: "2026-05-04T00:21:57.802Z",
    commitHash: "0ca5fc75f82e0e31d307aeffd6f8b70e11257e49",
};
